<template>
    <div class="mask" :class="(loaded)?'mask mask_fade_out':''">
        <img :src="bean" alt="">
    </div>
    
</template>
<script>
import bean from '../assets/brand-img.png';
export default {
    props: ['loaded'],
    data(){
        return {
            //header_loaded: false,
            bean
        }
        
    },
    mounted(){
        setTimeout(()=>{
            //this.header_loaded = true;

        },1000);
    }
}
</script>
<style lang="sass">



.mask
    position: fixed
    width: 100vw
    height: 100vh
    z-index: 10000
    background: black
    left: 0
    top: 0
    display: flex
    align-items: center
    justify-content: center
    transition: 0.5s
    opacity: 1
    img
        width: 120px
        //height: 50px
        animation: 1.5s infinite scale

.mask_fade_out
    opacity: 0
    pointer-events: none


@keyframes scale
    0%
        opacity: 0
        transform: scale(1) translateY(0)

    100%
        opacity: 1
        transform: scale(1.5) translateY(0)
</style>



// WEBPACK FOOTER //
// src/subview/Mask.vue